(function () {
  'use strict'

  require('./scss/video-youtube.scss')

  var MODULE_NAME = 'thismoment.common.component.videoYoutube'
  var templateUrl = require('./tpl/video-youtube.html')

  angular
    .module(MODULE_NAME, [
      require('../../analytics')
    ])
    .constant('YOUTUBE', {
      STOP: 0,
      PLAY: 1,
      PAUSE: 2,
      STATUS_CHANGE: 3
    })
    .factory('tmYouTubeApiService', tmYouTubeApiServiceFactory)
    .component('thismomentVideoYoutube', {
      bindings: {
        autoplay: '<',
        id: '@',
        item: '<',
        placeholder: '@',
        trackEvent: '&',
        videoUrl: '@'
      },
      templateUrl: templateUrl,
      controller: tmYoutubeController
    })

  tmYouTubeApiServiceFactory.$inject = ['$q', '$window']
  function tmYouTubeApiServiceFactory ($q, $window) {
    var deferred = $q.defer()
    var apiReady = deferred.promise

    $window.onYouTubeIframeAPIReady = function () {
      deferred.resolve()
    }

    return {
      onReady: function (callback) {
        apiReady.then(callback)
      }
    }
  }

  tmYoutubeController.$inject = ['$rootScope', '$scope', '$window', '$attrs', '$element', '$sce', 'tmYouTubeApiService', 'YOUTUBE']
  function tmYoutubeController ($rootScope, $scope, $window, $attrs, $element, $sce, tmYouTubeApiService, YOUTUBE) {
    var vm = this
    var urlPattern = /^(?:(https?:)?\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/

    vm.$onInit = onInit

    function onInit () {
      loadScriptYT()

      if (!vm.id) {
        var url = vm.videoUrl
        if (!url) {
          return
        }
        var r = url.match(urlPattern)
        if (!r) {
          return
        }
        vm.id = r[2]
      }

      vm.placeholderStyle = {
        backgroundImage: vm.placeholder ? 'url(' + vm.placeholder + ')' : 'url(' + $window.location.protocol + '//i.ytimg.com/vi/' + vm.id + '/hqdefault.jpg)'
      }

      tmYouTubeApiService.onReady(function () {
        setupPlayer($scope, $element, YOUTUBE, vm)
      })

      $scope.$on(YOUTUBE.PLAY, function () {
        vm.trackEvent({
          action: 'Content Converted',
          properties: {
            'event trigger': 'Video Started'
          }
        })
      })

      $scope.$on(YOUTUBE.PAUSE, function () {
        vm.trackEvent({
          action: 'Content Converted',
          properties: {
            'event trigger': 'Video Paused'
          }
        })
      })

      $scope.$on(YOUTUBE.ENDED, function () {
        $rootScope.$emit('videoCompleted')
        vm.trackEvent({
          action: 'Content Converted',
          properties: {
            'event trigger': 'Video Completed'
          }
        })
      })
    }
  }

  function setupPlayer ($scope, $element, YOUTUBE, vm) {
    $scope.showVideo = showVideo
    if (vm.autoplay) {
      showVideo()
    }

    function showVideo (event) {
      var el = $element.children().children()
      var dims = $element.children()[0].getBoundingClientRect()

      var player = new YT.Player(el.children()[0], {
        playerVars: {
          autoplay: 1,
          html5: 1,
          theme: 'light',
          modesbranding: 0,
          color: 'white',
          iv_load_policy: 3,
          showinfo: 1,
          controls: 1
        },
        height: dims.height,
        width: dims.width,
        videoId: vm.id,
        events: {
          'onStateChange': function (event) {
            var message = {
              event: YOUTUBE.STATUS_CHANGE,
              data: ''
            }

            switch (event.data) {
              case YT.PlayerState.PLAYING:
                message.event = YOUTUBE.PLAY
                break

              case YT.PlayerState.PAUSED:
                message.event = YOUTUBE.PAUSE
                break

              case YT.PlayerState.STOP:
                message.event = YOUTUBE.STOP
                break

              case YT.PlayerState.ENDED:
                message.event = YOUTUBE.ENDED
                break
            }

            $scope.$apply(function () {
              $scope.$emit(message.event)
            })
          }
        }
      })

      return player
    }
  }

  function loadScriptYT () {
    var scripts = document.getElementsByTagName('script')
    var loadScript = true

    for (var i = 0; i < scripts.length; i++) {
      if (scripts[i].src === 'https://www.youtube.com/iframe_api') {
        loadScript = false
        break
      }
    }
    if (loadScript) {
      var s = document.createElement('script')
      s.src = 'https://www.youtube.com/iframe_api'
      document.body.appendChild(s)
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/component/video-youtube.js